import http from '@root/utils/axios/admin';
const state = {
    token: localStorage.getItem('client/user-token') || '',
    errors: {},
    authUser: {},
    ProfileError: {}
};
const getters = {
    authToken(state) {
        return state.token;
    },

};

const actions = {

    register({ commit }, data) {

        return new Promise((resolve, reject) => {

            http.post('subscriber/register', data)
                .then(response => {
                    commit('authSuccess', response.data.access_token);

                    resolve(response);
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        commit('authError', error.response.data);
                    }

                    reject(error);
                });
        });
    },
    login({ commit }, data) {

        return new Promise((resolve, reject) => {

            http.post('subscriber/send-pin', data)
                .then(response => {
                    resolve(response);
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        if (!error.response.data.code) {
                            commit('authError', error.response.data);
                        }

                    }

                    reject(error);
                });
        });
    },
    loginConfirm({ commit }, data) {

        return new Promise((resolve, reject) => {

            http.post('subscriber/verify-pin', data)
                .then(response => {
                    commit('authSuccess', response.data.access_token);
                    resolve(response);
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        if (!error.response.data.code) {
                            commit('authError', error.response.data);
                        }
                    }

                    reject(error);
                });
        });
    },

    /**
     * Auth logout.
     */
    authLogout({ commit }) {

        return new Promise((resolve, reject) => {

            http.post('/subscriber/logout').then((response) => {
                    commit('authLogout');
                    resolve(response);
                })
                .catch((error) => {
                    commit('authLogout');
                    reject(error);
                });
        });
    },

    fetchAuth({ commit }) {
        return new Promise((resolve, reject) => {
            http.get('/subscriber/get-auth').then((response) => {
                commit('setAuthUser', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    trackVisitor({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/track-visitor', data)
                .then(response => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    updateProfile({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/subscriber/update-profile', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setProfileError', error.response.data);
                }
                reject(error.response);
            })
        });
    },
    updateProfilePhoto({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/subscriber/update-profile-photo', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setProfileError', error.response.data);
                }
                reject(error.response);
            })
        });
    },
    requestReactivation({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/subscriber/request-reactivation', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            })
        });
    },
    confirmReactivation({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/subscriber/confirm-reactivation', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            })
        });
    },

    requestCancellation({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/subscriber/request-cancellation', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            })
        });
    },
    confirmCancellation({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/subscriber/confirm-cancellation', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            })
        });
    },
    fetchProtectedScript({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/subscriber/get-anti-fraud-script', { params: filter }).then((response) => {
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

};
const mutations = {
    authSuccess(state, token) {
        localStorage.setItem('client/user-token', token);
        state.token = token;
        state.errors = {};
    },
    authLogout(state) {
        localStorage.removeItem('client/user-token');
        state.token = '';
    },
    authError(state, errors) {
        localStorage.removeItem('client/user-token');
        state.errors = errors.errors;
        state.token = '';
    },
    clearAuthToken(state, errors) {
        localStorage.removeItem('client/user-token');
        state.errors = errors;
        state.token = '';
    },

    setProfileError(state, errors) {
        state.ProfileError = errors.errors;
    },
    setAuthUser(state, data) {

        state.authUser = data;
    },

    loginCleanErrors(state) {
        state.errors = {};
    },
};

export default {
    state,
    actions,
    getters,
    mutations
}